class ShimmedCommandEvent extends Event {
  constructor(command) {
    super("command", { bubbles: true });
    this.command = command;
  }
}

if (!window.CommandEvent) {
  console.log("Adding shim for command events");
  document.addEventListener("click", function(e) {
    if (e.target.hasAttribute("command")) {
      let command = e.target.getAttribute("command");
      let id = e.target.getAttribute("commandfor");
      if (!id) return;
      let target = document.getElementById(id);
      target?.dispatchEvent(new ShimmedCommandEvent(command));
    }
  });

  document.addEventListener("command", function(e) {
    if (e.command == "close" && e.target.close) {
      e.target.close();
    }
    if (e.command == "show" && e.target.show) {
      e.target.show();
    }
  });
}

// shim popover targets?
if (!("popover" in document.body)) {
  class ShimmedToggleEvent extends Event {
    constructor(action, oldState, newState) {
      super("toggle", { bubbles: true });
      this.oldState = oldState;
      this.newState = newState;
      this.action = action;
    }
  }

  class ShimmedPopoverTargetEvent extends Event {
    constructor(action) {
      super("--popover");
      this.action == action;
    }
  }


  for (let popover of document.querySelectorAll(`[popover]`)) {
    popover.addEventListener("--popover", function(e) {
      let event;
      if (this.tagName.toLowerCase() == "dialog") {
        // are we open?
        let oldState = this.open ? "open" : "closed";
        let newState = e.action == "show" ? "open" :
          e.action == "hide" ? "closed" :
          this.open ? "closed" : "open";
        event = new ShimmedToggleEvent(e.action, oldState, newState);
      } else {
        let oldState = this.hasAttribute("hidden") ? "closed" : "open";
        let newState = e.action == "show" ? "open" :
          e.action == "hide" ? "closed" :
          oldState == "open" ? "closed" : "open";
        event = new ShimmedToggleEvent(e.action, oldState, newState);
      }
      this.dispatchEvent(event);
    });
    popover.addEventListener("toggle", function(e) {
      console.log(e);
      if (this.tagName.toLowerCase() == "dialog") {
        this[e.newState == "open" ? "show" : "close"]();
      } else {
        this.toggleAttribute("hidden", e.newState == "closed");
      }
    });
    popover.hidePopover = function() {
      this.dispatchEvent(new ShimmedToggleEvent("hide"));
    }
    popover.showPopover = function() {
      this.dispatchEvent(new ShimmedToggleEvent("show"));
    }
  }
  window.addEventListener("click", function(e) {
    e.preventDefault();
    if (e.target.hasAttribute("popovertarget")) {
      let popover = document.getElementById(e.target.getAttribute("popovertarget"));
      popover.dispatchEvent(new ShimmedPopoverTargetEvent(e.target.getAttribute("popovertargetaction")));
    }
  });
}